export const getPatientName = (
  patientFirstname: string = '',
  patientLastname: string = '',
): string => {
  return [patientLastname, patientFirstname].filter(Boolean).join(', ');
};
